// eslint-disable-next-line import/prefer-default-export
export const disabledPathes = ['/user/', '/petition-field-report', '/landing-page/'];
